import script from "./UserCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCenter.vue?vue&type=script&setup=true&lang=js"

import "@/features/user/styles/UserCenter.css?vue&type=style&index=0&id=106f8f5e&scoped=true&lang=css&external"
import "@/features/user/styles/UserCenterMobile.css?vue&type=style&index=1&id=106f8f5e&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-106f8f5e"]])

export default __exports__